import React from "react";
import Box from "@mui/material/Box";
import { Grid, DialogContent, Dialog } from "@material-ui/core";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import CustomReport from './customReport'


export default function DownloadReportMain(props) {
    const { open, setOpen } = props;

    const handleClose = () => {
        setOpen(false);
    }
    return (
        <Dialog
            open={open}
            onClose={() => handleClose()}
            maxWidth="sm"
            fullWidth
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Grid item xs={12} sm={12} md={12}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <ModalCloseButton onClick={() => handleClose()} style={{ position: "static" }} />
                </Box>
            </Grid>
            <DialogContent>
                {<CustomReport onClose={handleClose} />}
            </DialogContent>
        </Dialog >
    );
}
